import React, { useEffect, useState } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import navbarimage from "assets/img/auth/auth.png";
import { BsArrowBarUp } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
  IoMdDownload,
  IoMdClose,
} from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";
import { socket } from "socket";

import { getOneReportDetailsApi } from "api/gestionStock";
import {
  getNotificationsForOperatorApi,
  markNotificationAsReadApi,
  clearOneNotificationApi,
  clearAllNotificationsApi,
} from "api/notification";
import {
  pdfBcGeneratorApi,
  pdfBlGeneratorApi,
  pdfInvoceGeneratorApi,
  pdfBaGeneratorApi,
  pdfBrGeneratorApi,
  pdfAvoirGeneratorApi,
  pdfRecouvryGeneratorApi,
  pdfDevisGeneratorApi,
  pdfVisiteEssayGeneratorApi,
  pdfVisiteDeveloppementGeneratorApi,
} from "api/pdf";

const DOC_NUMBER_LABELS = {
  BC: "RBC",
  BL: "RBL",
  F: "RF",
  MagasinierTwo: "RBL2",
};

const Navbar = (props) => {
  const navigate = useNavigate();

  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = useState(false);
  const [reportNotifications, setReportNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      const data = await getNotificationsForOperatorApi();
      setReportNotifications(Array.isArray(data) ? data : []);
    } catch (err) {
      console.warn("Failed to fetch notifications", err);
    }
  };

  // Notifications are persisted server-side (Notification collection), so
  // they survive a page refresh. They only disappear from this list once
  // the user hits "Tout effacer" (clearAll), which tombstones them per-operator.
  useEffect(() => {
    fetchNotifications();

    const onNewNotification = () => {
      fetchNotifications();
    };

    socket.on("newNotification", onNewNotification);
    return () => socket.off("newNotification", onNewNotification);
  }, []);

  const unreadCount = reportNotifications.filter((notif) => !notif.isReaded).length;

  const handleOpenNotification = async (notif) => {
    if (notif.isReaded) return;

    try {
      await markNotificationAsReadApi(notif._id);
      setReportNotifications((prev) =>
        prev.map((el) => (el._id === notif._id ? { ...el, isReaded: true } : el))
      );
    } catch (err) {
      console.warn("Failed to mark notification as read", err);
    }
  };

  const handleClearOneNotification = async (notif) => {
    try {
      await clearOneNotificationApi(notif._id);
      setReportNotifications((prev) => prev.filter((el) => el._id !== notif._id));
    } catch (err) {
      console.warn("Failed to clear notification", err);
    }
  };

  const handleClearAllNotifications = async () => {
    try {
      await clearAllNotificationsApi();
      setReportNotifications([]);
    } catch (err) {
      console.warn("Failed to clear notifications", err);
    }
  };

  const handleLogout = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
    }

    navigate("/auth");
  };

  const getFirstCategory = (report) => {
    const rapport = report?.Rapport;
    if (!rapport || typeof rapport !== "object") return "all";
    const keys = Object.keys(rapport).filter(
      (k) => k !== "produits" && k !== "recouvrement"
    );
    if (keys.length) return keys[0];
    if (rapport.recouvrement && typeof rapport.recouvrement === "object") {
      const recKeys = Object.keys(rapport.recouvrement);
      if (recKeys.length) return recKeys[0];
    }
    return Object.keys(rapport)[0] || "all";
  };

  const handleDownloadReport = async (notif) => {
    try {
      const reportId = notif.fromRapportID;
      const details = await getOneReportDetailsApi(reportId);
      if (!details) return;
      const mode = details.ModeOperation || "Vente";
      const category = getFirstCategory(details);
      const cities =
        details?.MagasinStock?.flat?.(1)?.map((el) => el?.city) || [];
      const firstCity = cities[0] || "all";
      let url;
      switch (mode) {
        case "Vente":
          url = await pdfBcGeneratorApi(reportId, category, 0);
          break;
        case "Avoir":
          url = await pdfBaGeneratorApi(reportId, category, 0);
          break;
        case "Recouvrement":
          url = await pdfRecouvryGeneratorApi(reportId, category);
          break;
        case "Devis":
          url = await pdfDevisGeneratorApi(reportId, category, 0);
          break;
        case "VisiteEssai":
          url = pdfVisiteEssayGeneratorApi(reportId);
          break;
        case "VisiteDeveloppement":
          url = pdfVisiteDeveloppementGeneratorApi(reportId);
          break;
        default:
          url = await pdfBcGeneratorApi(reportId, category, 0);
      }
      if (url) window.open(url, "_blank");
    } catch (err) {
      console.warn("Download report failed", err);
    }
  };

  return (
    <nav className="sticky top-0 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[250px] xl:gap-2">
        {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            class="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div> */}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        <Dropdown
          button={
            <p className="relative cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
              {unreadCount > 0 && (
                <span className="absolute -right-1 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
                  {unreadCount}
                </span>
              )}
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                {reportNotifications.length > 0 && (
                  <button
                    type="button"
                    onClick={handleClearAllNotifications}
                    className="text-sm font-bold text-brand-500 hover:underline dark:text-white"
                  >
                    Tout effacer
                  </button>
                )}
              </div>

              <div className="flex max-h-[360px] flex-col gap-3 overflow-y-auto pr-1">
              {reportNotifications.length === 0 ? (
                <p className="py-2 text-sm text-gray-500 dark:text-gray-400">
                  Aucune notification
                </p>
              ) : (
                reportNotifications.map((notif) => (
                  <div
                    key={notif._id}
                    onClick={() => handleOpenNotification(notif)}
                    className={`flex w-full cursor-pointer items-center gap-2 rounded-lg border p-2 dark:border-white/10 ${
                      notif.isReaded
                        ? "border-gray-200"
                        : "border-brand-500 bg-lightPrimary dark:bg-navy-900"
                    }`}
                  >
                    <div className="ml-2 flex min-w-0 flex-1 flex-col justify-center px-1 text-sm">
                      <div className="mb-0.5 flex items-center gap-2">
                        <p className="text-left text-base font-bold text-gray-900 dark:text-white">
                          {notif.title}
                        </p>
                        {notif.docNumber && DOC_NUMBER_LABELS[notif.type] && (
                          <span className="shrink-0 rounded-full bg-brand-500 px-2 py-0.5 text-[10px] font-bold text-white">
                            {DOC_NUMBER_LABELS[notif.type]}: {notif.docNumber}
                          </span>
                        )}
                      </div>
                      <p className="text-left text-xs text-gray-600 dark:text-gray-300">
                        {notif.text}
                      </p>
                      {notif.date && (
                        <p className="mt-1 text-left text-xs text-gray-400 dark:text-gray-500">
                          {notif.date} {notif.time}
                        </p>
                      )}
                    </div>
                    {notif.fromRapportID && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownloadReport(notif);
                        }}
                        className="shrink-0 rounded-full p-2 text-navy-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/10"
                        title="Télécharger le rapport PDF"
                      >
                        <IoMdDownload className="h-5 w-5" />
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearOneNotification(notif);
                      }}
                      className="shrink-0 rounded-full p-2 text-navy-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/10"
                      title="Effacer cette notification"
                    >
                      <IoMdClose className="h-5 w-5" />
                    </button>
                  </div>
                ))
              )}
              </div>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        {/* start Horizon PRO */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="#"
                className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
              >
                Ard unifert maroc V3.0.0
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={avatar}
              alt="Elon Musk"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, Adela
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <a
                  href=" "
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </a>
                <a
                  href=" "
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Newsletter Settings
                </a>
                <a
                  href=""
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
                  onClick={handleLogout}
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
